import brand from '@helpers/brand';
import styled, { css, keyframes } from 'styled-components';
const loadAnimation = keyframes `
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
const Loader = styled.div `
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation: ${loadAnimation} 1.1s infinite linear;
  border-radius: 50%;

  ${({ inline }) => inline
    ? css ``
    : css `
          margin: 60px auto;
        `}

  ${({ size }) => css `
    width: ${size}px;
    height: ${size}px;

    &:after {
      content: '';
      border-radius: 50%;
      width: ${size}px;
      height: ${size}px;
    }
  `}
  

  ${({ theme, width }) => {
    switch (theme) {
        case 'black':
        default:
            return css `
          border-top: ${width}px solid rgba(0, 0, 0, 0.1);
          border-right: ${width}px solid rgba(0, 0, 0, 0.1);
          border-bottom: ${width}px solid rgba(0, 0, 0, 0.1);
          border-left: ${width}px solid ${brand.nearlyBlack};
        `;
        case 'white':
            return css `
          border-top: ${width}px solid rgba(255, 255, 255, 0.3);
          border-right: ${width}px solid rgba(255, 255, 255, 0.3);
          border-bottom: ${width}px solid rgba(255, 255, 255, 0.3);
          border-left: ${width}px solid ${brand.white};
        `;
        case 'current':
            return css `
          border-top: ${width}px solid currentColor;
          border-right: ${width}px solid currentColor;
          border-bottom: ${width}px solid currentColor;
          border-left: ${width}px solid ${brand.grey[50]};
        `;
    }
}}
`;
const Wrapper = styled.div `
  ${({ absolute }) => absolute
    ? css `
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        `
    : null}

  ${({ fillContainer }) => fillContainer
    ? css `
          width: 100%;
          height: 100%;
          grid-column: 1 / -1;
          display: flex;
          justify-content: center;
          align-items: center;
        `
    : null}
`;
export const LoaderStyles = {
    Wrapper,
    Loader,
};
